module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table"
  }, [(_vm.figures.includes(4.1) || _vm.figures.includes(4.3)) ? _c('table', {
    staticClass: "table-4"
  }, [_c('tbody', [_c('tr', [_c('td'), _vm._v(" "), _vm._l((_vm.dataSource.groups), function(group) {
    return _c('td', {
      staticClass: "center-aligned",
      attrs: {
        "colspan": "5"
      }
    }, [_vm._v("\n          " + _vm._s(group) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', {
    staticStyle: {
      "height": "30px",
      "vertical-align": "top"
    }
  }, [_c('td'), _vm._v(" "), _vm._l((_vm.dataSource.header), function(year, index) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v(_vm._s(index === 0 ? year : ("'" + (year.toString().slice(-2)))))])
  })], 2), _vm._v(" "), _vm._l((_vm.dataSource.rows), function(row) {
    return _c('tr', [_c('td', {
      class: row.name.replace(' ', '-').toLowerCase()
    }, [_vm._v("\n          " + _vm._s(row.name) + "\n        ")]), _vm._v(" "), _vm._l((row.data), function(data) {
      return _c('td', {
        staticClass: "right-aligned",
        class: row.name.replace(' ', '-').toLowerCase()
      }, [_vm._v("\n          " + _vm._s(data) + "\n        ")])
    })], 2)
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.figures.includes(6)) ? _c('table', {
    staticClass: "table-6"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)]) : _vm._e(), _vm._v(" "), (_vm.figures.includes(9)) ? _c('table', {
    staticClass: "table-9",
    style: ({
      minWidth: _vm.width + 'px'
    })
  }, [_c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), (_vm.visibleFor('fha')) ? _c('td', {
    staticClass: "right-aligned bottom-aligned"
  }, [_vm._v("Fraser")]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('iha')) ? _c('td', {
    staticClass: "right-aligned bottom-aligned"
  }, [_vm._v("Interior")]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('viha')) ? _c('td', {
    staticClass: "right-aligned bottom-aligned"
  }, [_vm._v("Island")]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('nha')) ? _c('td', {
    staticClass: "right-aligned bottom-aligned"
  }, [_vm._v("Northern")]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('vcha')) ? _c('td', {
    staticClass: "right-aligned bottom-aligned"
  }, [_vm._v("Vancouver"), _c('br'), _vm._v("Coastal")]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('bc')) ? _c('td', {
    staticClass: "right-aligned bottom-aligned"
  }, [_vm._v("Total BC")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "grey"
  }, [_vm._v("Age")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("< 30")]), _vm._v(" "), (_vm.visibleFor('fha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['< 30'].fha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('iha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['< 30'].iha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('viha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['< 30'].viha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('nha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['< 30'].nha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('vcha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['< 30'].vcha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('bc')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['< 30'].bc))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("30–39")]), _vm._v(" "), (_vm.visibleFor('fha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['30–39'].fha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('iha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['30–39'].iha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('viha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['30–39'].viha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('nha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['30–39'].nha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('vcha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['30–39'].vcha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('bc')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['30–39'].bc))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "grey"
  }), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("40–49")]), _vm._v(" "), (_vm.visibleFor('fha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['40–49'].fha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('iha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['40–49'].iha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('viha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['40–49'].viha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('nha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['40–49'].nha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('vcha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['40–49'].vcha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('bc')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['40–49'].bc))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("≥ 50")]), _vm._v(" "), (_vm.visibleFor('fha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['≥ 50'].fha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('iha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['≥ 50'].iha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('viha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['≥ 50'].viha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('nha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['≥ 50'].nha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('vcha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['≥ 50'].vcha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('bc')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['≥ 50'].bc))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "grey"
  }, [_vm._v("Gender")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("Male")]), _vm._v(" "), (_vm.visibleFor('fha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Male'].fha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('iha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Male'].iha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('viha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Male'].viha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('nha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Male'].nha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('vcha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Male'].vcha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('bc')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Male'].bc))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("Female")]), _vm._v(" "), (_vm.visibleFor('fha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Female'].fha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('iha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Female'].iha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('viha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Female'].viha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('nha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Female'].nha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('vcha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Female'].vcha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('bc')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Female'].bc))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "grey"
  }, [_vm._v("Exposure")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("MSM")]), _vm._v(" "), (_vm.visibleFor('fha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['MSM'].fha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('iha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['MSM'].iha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('viha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['MSM'].viha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('nha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['MSM'].nha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('vcha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['MSM'].vcha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('bc')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['MSM'].bc))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("PWID")]), _vm._v(" "), (_vm.visibleFor('fha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['PWID'].fha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('iha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['PWID'].iha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('viha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['PWID'].viha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('nha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['PWID'].nha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('vcha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['PWID'].vcha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('bc')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['PWID'].bc))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "grey"
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }), _vm._v(" "), (_vm.visibleFor('fha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Total'].fha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('iha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Total'].iha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('viha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Total'].viha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('nha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Total'].nha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('vcha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Total'].vcha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('bc')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Total'].bc))]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Programmatic"), _c('br'), _vm._v("Compliance Score")]), _vm._v(" "), _c('td', [_vm._v("Mortality Risk Ratio"), _c('br'), _vm._v("(95% Confidence Interval)"), _c('br')]), _vm._v(" "), _c('td', [_vm._v("Immunologic Failure Risk"), _c('br'), _vm._v("Ratio (95% CI)")]), _vm._v(" "), _c('td', [_vm._v("Virologic Failure Risk Ratio"), _c('br'), _vm._v("(95% CI)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "grey"
  }, [_vm._v("0 (Best score)")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("1 (–)")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("1 (–)")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("1 (–)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("3.81 (1.73–8.42)")]), _vm._v(" "), _c('td', [_vm._v("1.39 (1.04–1.85)")]), _vm._v(" "), _c('td', [_vm._v("1.32 (1.05–1.67)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "grey"
  }, [_vm._v("2")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("7.97 (3.70–17.18)")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("2.17 (1.54–3.04)")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("1.86 (1.46–2.38)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_vm._v("11.51 (5.28–25.08)")]), _vm._v(" "), _c('td', [_vm._v("2.93 (1.89–4.54)")]), _vm._v(" "), _c('td', [_vm._v("2.98 (2.16–4.11)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "grey"
  }, [_vm._v("4 or more"), _c('br'), _vm._v("(Worst score)")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("22.37 (10.46–47.84)")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("9.71 (5.72–16.47)")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("3.80 (2.52–5.73)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7664f838"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/web/components/DataTable.vue
// module id = 134
// module chunks = 0